export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-speed-limit-960-6846799ff378c65f2ed8968db016cacb.png";